'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('onyxReadingRoomApp.appconfs.list', [])
  .controller('AppConfsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/list/index.js